import Highlight from "highlight.js/lib/highlight";
import json from "highlight.js/lib/languages/json";
import "highlight.js/styles/github-gist.css";

Highlight.registerLanguage("json", json);

export default Highlight;
